import { ENV } from '@/infrastructure/env-config';
import { Platform } from '@/infrastructure/utils/app';

/**
 * 产品相关
 */
export default {
  demoProduct: ENV.isProd ? [
    { productId: 'bccbf14499', platformId: Platform.Android },
    { productId: 'd01e411bf0', platformId: Platform.IOS },
  ] : [
    { productId: '129a7bcc6e', platformId: Platform.Android }, // 测试环境
  ],
};
